module.exports = __webpack_public_path__ + "img/IMG_9321_L.d840b92e.webp";